import MoreVertIcon from '@mui/icons-material/MoreVert';

export const MoreVerticalIconMUI = MoreVertIcon;
